import React from 'react'

export const CheckCircle = ({ className }) => (
  <svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		className={className}
	>
    <g className="fill-current" fillRule="nonzero">
      <path d="M22.697 2.662a1.032 1.032 0 0 0-1.46 0l-9.59 9.589L8.25 8.853a1.033 1.033 0 0 0-1.46 1.46l4.127 4.128a1.032 1.032 0 0 0 1.46 0l10.32-10.32a1.032 1.032 0 0 0 0-1.46Z" />
      <path d="M22.77 9.203a1.046 1.046 0 0 0-2.05.418 9.408 9.408 0 1 1-4.625-6.325 1.048 1.048 0 0 0 1.024-1.83 11.5 11.5 0 1 0 5.651 7.737Z" />
    </g>
  </svg>
)
export const XCircle = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={className}
  >
    <path
      className="fill-current"
      fillRule="nonzero"
      d="m13.414 12 3.183 3.183a1 1 0 0 1-1.414 1.414L12 13.414l-3.183 3.183a1 1 0 0 1-1.414-1.414L10.586 12 7.403 8.817a1 1 0 0 1 1.414-1.414L12 10.586l3.183-3.183a1 1 0 0 1 1.414 1.414L13.414 12ZM12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12Zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
    />
  </svg>
)
export const ChevronRight = ({ className }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth="3" 
    stroke="currentColor"
    className={className}
  >
    <path 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      d="M8.25 4.5l7.5 7.5-7.5 7.5"
    />
  </svg>  
)
export const ChevronLeft = ({ className }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth="3" 
    stroke="currentColor"
    className={className}
  >
    <path 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      d="M15.75 19.5L8.25 12l7.5-7.5"
    />
  </svg>  
)
export const ArrowRight = ({ className }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth="2.5" 
    stroke="currentColor" 
    className={className}
  >
    <path 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" 
    />
  </svg>  
)
export const ArrowLeft = ({ className }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth="2.5" 
    stroke="currentColor" 
    className={className}
  >
    <path 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" 
    />
  </svg>  
)